import { useMemo } from 'react';
import { prop } from 'ramda';
import { useUserSelector, useAppSelector } from 'js/store/hooks';

import placeholderImage from '../images/game_placeholder.svg';

export const useGameImageUrls = (
    { code, dynamicImageUrl, isLiveGame }: { code: string; dynamicImageUrl?: string; isLiveGame?: boolean }
): string[] => {
    const games = useAppSelector(prop('games'));
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    return useMemo(() => {
        const images = games?.[code]?.images || { guest: '', base: '' };
        const cmsImageUrl = !isLoggedIn && images.guest || images.base;

        return [
            ...isLiveGame && dynamicImageUrl ? [dynamicImageUrl] : [],
            cmsImageUrl,
            placeholderImage
        ];
    }, [code, isLiveGame, dynamicImageUrl, games, isLoggedIn]);
};
